import { createEntityExtension } from "../mystekz-linked-entities";
import { ProcessesManager } from "./manager";
import { LinkedEntity } from "../mystekz-linked-entities";
import { type ProcessInTree } from "@/stores/processes-store";
import { h } from "vue";
import { vnodeToHtml } from "@/utils";
import GenericCard from "@/components/EntityInfo/GenericCard.vue";
import { EntityType } from "@/stores/entity-store";

export type ProcessEntity = LinkedEntity<"process", ProcessInTree>;

let processesManager: ProcessesManager;
/**
 * Get the business entity manager for a given domain.
 */
export const getProcessesManager = (baseUrl: string) => {
    if (!processesManager) {
        processesManager = new ProcessesManager(baseUrl);
    }
    return processesManager;
};

export const ProcessesExtension = createEntityExtension(
    "process",
    import.meta.env.VITE_BASE_URL,
    true,
    {
        popup: {
            key: "processDetails",
            hover: true,
            create: (_: Promise<ProcessEntity | void>, entityId: string) => {
                return () => {
                    return vnodeToHtml(
                        h(GenericCard, {
                            entityId,
                            entityType: EntityType.PROCESS,
                        })
                    );
                };
            },
        },
        prefix: "",
    },
    {
        popup: {
            key: "processInsert",
        },
    },
    getProcessesManager,
    {
        label: "Processes",
        showInInlineMenu: true,
        caret: true,
        icon: {
            name: "pi-share-alt",
            library: "primeicons",
        },
        group: "Linked Entities",
    }
);
